import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';

//store functions
import {initFundial, resetPage, goToPage, getSubscribers, setIsBackNavigationDone, setIsListenerAdded} from './fundialSlice';

//page wrapper
import PurpleWrapper from './Shared/PurpleWrapper/PurpleWrapper';

//pages
import LobbyPage from './Pages/LobbyPage';
import CatalogPage from './Pages/CatalogPage';
import OtpPage from './Pages/OtpPage';
import PersonalAreaPage from './Pages/PersonalAreaPage';
import DownloadSongPage from './Pages/DownloadSongPage';
import SubscriberListPage from './Pages/SubscriberListPage';
import SongListPage from './Pages/SongListPage';
import DownloadedSetupPage from './Pages/DownloadedSetupPage';
import CategoryPage from './Pages/CategoryPage';
import ErrorPage from './Pages/ErrorPage';
import SongSetupSuccessPage from './Pages/SongSetupSuccessPage';

const Fundial = (props) => {
  let currentView = null;

  //--------------- useEffect ---------------
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.initFundial();
    }
    return () => {
      props.resetPage();
    };
  }, []);

  const getSubscribers = async () => {
    const subscribers = await props.getSubscribers();
    if (subscribers.payload.errorCode == 0) {
      props.goToPage({page: 'lobbyPage'});
    }
  };

  useEffect(() => {
    if (props.isAuthenticateFinish) {
      if (!props.isAuthenticated) {
        props.resetPage();
        props.goToPage({page: 'lobbyPage'});
      } else if (!props.isFinishedGetSubscribers) {
        if (props.page != 'otpPage') {
          getSubscribers();
        }
      } else {
        props.goToPage({page: 'lobbyPage'});
      }
    }
  }, [props.isAuthenticateFinish, props.isAuthenticated]);

  function handlePopState(event) {
    // The user clicked the back button
    if (!window.location.hash && !props.isBackNavigationDone) {
      window.removeEventListener('popstate', handlePopState);
      window.history.go(-1);
    }
  }

  useEffect(() => {
    if (!props.isListenerAdded) {
      window.addEventListener('popstate', handlePopState);
      props.setIsBackNavigationDone(false);
      props.setIsListenerAdded(true);
    }
  }, [window.location.hash]);

  useClearStateResetFlag();

  switch (props.page) {
    case 'lobbyPage':
      // case '':
      currentView = <LobbyPage />;
      break;
    case 'catalogPage':
      currentView = <CatalogPage />;
      break;
    case 'otpPage':
      currentView = <OtpPage />;
      break;
    case 'personalAreaPage':
      currentView = <PersonalAreaPage />;
      break;
    case 'downloadSongPage':
      currentView = <DownloadSongPage />;
      break;
    case 'subscriberListPage':
      currentView = <SubscriberListPage />;
      break;
    case 'songListPage':
      currentView = <SongListPage />;
      break;
    case 'downloadedSetupPage':
      currentView = <DownloadedSetupPage />;
      break;
    case 'categoryPage':
      currentView = <CategoryPage />;
      break;
    case 'errorPage':
      currentView = <ErrorPage />;
      break;
    case 'songSetupSuccessPage':
      currentView = <SongSetupSuccessPage />;
      break;
  }

  return (
    <div className='fundial'>
      <PurpleWrapper>{currentView}</PurpleWrapper>
    </div>
  );
};
const mapStateToProps = (state) => {
  const {isOtpAuthenticated, isFullAuthenticated, isOtpExtendedAuthenticated, isSilentOtpAuthenticated} = state.authentication.loginData;

  return {
    page: state.fundialPage.navigation.currentPage,
    isAuthenticateFinish: state.authentication.isAuthenticateFinish,
    isFinishedGetSubscribers: state.fundialPage.isFinishedGetSubscribers,
    isBackNavigationDone: state.fundialPage.isBackNavigationDone,
    isListenerAdded: state.fundialPage.isListenerAdded,
    isAuthenticated: isOtpAuthenticated || isFullAuthenticated || isOtpExtendedAuthenticated || isSilentOtpAuthenticated,
  };
};

const mapDispatchToProps = {initFundial, resetPage, goToPage, getSubscribers, setIsBackNavigationDone, setIsListenerAdded};

export default connect(mapStateToProps, mapDispatchToProps)(Fundial);
